import {BaseContainerModel} from '../../base-container.model';
import {bl_inv_bin_hdr_RowClass} from '../../../dbschema/bl_inv_bin_hdr.model';

export class BinHdrModel extends BaseContainerModel {
  bl_inv_bin_hdr: bl_inv_bin_hdr_RowClass = new bl_inv_bin_hdr_RowClass();
}
